import Request from "../core/httpClient";



const request = new Request();

export function useSuperCore() {
  const getUserInfo = async () => {
    const iGateAdmin = JSON.parse(localStorage.getItem('iGateAdmin'));
    return await request.post('/admin/administracion/get/decodetoken', {
      token: iGateAdmin.id
    });
  };

  const openModal = (idModal) => {
    const modal = document.getElementById(idModal);
    if (modal) {
      modal.classList.remove('hide-dinamic-modal');
      modal.classList.add('show-dinamic-modal');
    }
  };

  const closeModal = (idModal) => {
    const modal = document.getElementById(idModal);
    if (modal) {
      modal.classList.add('hide-dinamic-modal');
      modal.classList.remove('show-dinamic-modal');
    }
  };


    // Nuevo: abrir modal de borrado
  const openModalDelete = (idModal = "deleteModal") => {
    const modal = document.getElementById(idModal);
    if (modal) {
      modal.classList.remove("hide-modal");
      modal.classList.add("show-modal");
    }
  };

    // Nuevo: cerrar modal de borrado
  const closeModalDelete = (idModal = "deleteModal") => {
    const modal = document.getElementById(idModal);
    if (modal) {
      modal.classList.add("hide-modal");
      modal.classList.remove("show-modal");
    }
  };


  // useSuperCore.js
const getSubmenuOpeName = async () => {
  const response = await request.post("/admin/operacion/get/submenu", {});
  return response?.submenu || "";
};

const loadUser = async () => {
  const response = await getUserInfo();
  if (response) {
    return {
      idUsuario: response.id.id_usuario,
      idPerfil: response.id.id_perfil,
      idFraccionamiento: response.id.id_fraccionamiento,
      nombre: response.id.nombre,
    };
  }
  return null;
};

return {
  getUserInfo,
  getSubmenuOpeName,
  loadUser,
  openModal,
  closeModal,
  openModalDelete,
  closeModalDelete,
};

  

  
}